import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ['currentItem'];

  connect() {
    this._boundUpdateHandler = this._updateCurrentBreadCrumb.bind(this);

    document.addEventListener('promote:navigation-breadcrumbs:update-last', this._boundUpdateHandler);
  }

  disconnect() {
    document.removeEventListener('promote:navigation-breadcrumbs:update-last', this._boundUpdateHandler);
  }

  updateCurrentBreadcrumb(text) {
    this.currentItemTarget.innerHTML = text;
  }

  _updateCurrentBreadCrumb(event) {
    this.updateCurrentBreadcrumb(event.detail.text);
  }
}
